module.exports = __webpack_public_path__ + "img/3.fa813f8.png";